import { useEffect, useState, useCallback } from "react";
import { supabase } from "@/lib/supabase";

export interface IndicadorDB {
  id: number;
  valor: number;
  titulo: string;
  subtitulo: string;
  posicion: "left" | "right";
  orden: number;
  created_at: string;
}

export function useIndicadores() {
  const [data, setData] = useState<IndicadorDB[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data: result, error: err } = await supabase
        .from("indicadores")
        .select("*")
        .order("orden", { ascending: true });
      if (err) throw err;
      setData(result as IndicadorDB[] ?? []);
    } catch {
      setError("Error cargando indicadores");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
}